import komunitasBg from '../../../../assets/svgs/komunitas.svg';
import tempatBg from '../../../../assets/svgs/tempat.svg';
import personalBrandBg from '../../../../assets/svgs/personal_brand.svg';
import merchandiseBg from '../../../../assets/svgs/merchandise.svg';

export const content = [
  {
    img: komunitasBg,
    title: 'Komunitas',
    desc: 'Bergabung dengan komunitas yang berisi musisi-musisi terbaik.',
  },
  {
    img: tempatBg,
    title: 'Tempat Ngamen',
    desc: 'Ngamen di tempat yang sudah tersedia di platform kami.',
  },
  {
    img: personalBrandBg,
    title: 'Personal Brand',
    desc:
      'Bangun personal brand sebagai musisi berkualitas dengan platform kami.',
  },
  {
    img: merchandiseBg,
    title: 'Merchandise',
    desc:
      'Merchandise eksklusif Ngamen Hub supaya penampilan kamu jadi lebih mbois.',
  },
];
